import { COMPONENT_DISPLAY_NAME, LAYER_TYPE } from 'common/constants';
import { generateElementId, generateNodeId } from 'utils/generate-id';
import type { BBModel, ComponentTypes } from 'types/story';

type CreateModelOptions<TType extends ComponentTypes, TChildren, TEditorProps extends object = {}> = {
	type: TType;
	componentProps: BBModel<TType, TChildren, TEditorProps>['uiConfig']['componentProps'];
	children: TChildren;
	editorProps?: Partial<BBModel<TType, TChildren, TEditorProps>['uiConfig']['editorProps']>;
	name?: string;
	nodeType?: ComponentTypes | 'fla' | 'flb';
};

export const createModel = <TType extends ComponentTypes, TChildren, TEditorProps extends object = {}>({
	type,
	componentProps,
	children,
	editorProps,
	name,
	nodeType = type,
}: CreateModelOptions<TType, TChildren, TEditorProps>): BBModel<TType, TChildren, TEditorProps> => {
	const _id = generateElementId();

	return {
		_id,
		type,
		uiConfig: {
			layer: LAYER_TYPE.CONTENT,
			editorProps: {
				name: name ?? COMPONENT_DISPLAY_NAME[type],
				selectable: true,
				draggable: true,
				expandable: false,
				expanded: false,
				...editorProps,
			} as BBModel<TType, TChildren, TEditorProps>['uiConfig']['editorProps'],
			componentProps,
			nodeProps: {
				id: generateNodeId(_id, nodeType),
			},
		},
		children,
	};
};
